import dayjs from 'dayjs'
import { z } from 'zod'

import { timeRangeOptions } from '@/lib/date'

const defaultDateRange = {
  startDate: dayjs().subtract(3, 'hours').toISOString(),
  endDate: dayjs().toISOString(),
}
const defaultTimeRange = '3h'

export const SearchSchema = z.object({
  sites: z.array(z.string()).optional(),
  buildings: z.array(z.string()).optional(),
  equipments: z.array(z.string()).optional(),
  siteHistory: z.string().optional(),
  buildingHistory: z.string().optional(),
  floorHistory: z.string().optional(),
  floorsHistory: z.array(z.string()).optional(),
  spacesHistory: z.array(z.string()).optional(),
  startDate: z.string().default(defaultDateRange.startDate),
  endDate: z.string().default(defaultDateRange.endDate),
  timeRange: z.enum(timeRangeOptions).default(defaultTimeRange),
  // nullish: URLs minted while the ECS chart passed a null parentId (floor
  // with several hotWater macros) must keep parsing instead of crashing the
  // page; null is normalized back to undefined for consumers. Kept as a
  // legacy fallback for old links — new ECS clicks emit the plural param.
  equipmentParentIdHistory: z
    .string()
    .nullish()
    .transform((value) => value ?? undefined),
  equipmentParentIdsHistory: z.array(z.string()).optional(),
})

export type Search = z.infer<typeof SearchSchema>
